import request from "_private/utils/request";

/**
 * 获取仓库监控列表数据
 * @param {*} data
 */
export function FetchStorageListByPage(data) {
    return request({
        url: "/monitorCenter/monitorStorage/getStorageList",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 获取门店监控列表数据
 * @param {*} data
 */
export function FetchStoreListByPage(data) {
    return request({
        url: "/monitorCenter/monitorStore/getStoreList",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 获取企业监控列表数据
 * @param {*} data
 */
export function FetchComparyListByPage(data) {
    return request({
        url: "/monitorCenter/monitorCompany/companyMonitPoint",
        method: "post",
        data
    });
}
